import {PriceModel} from './Price.model';
import {PriceSummary} from '@wix/auto_sdk_ecom_current-cart';
import {ModelContext} from '../../types/app.types';

export class PriceSummaryModel {
  public subtotal: PriceModel;
  public shipping: PriceModel;
  public tax: PriceModel;
  public discount: PriceModel;
  public total: PriceModel;
  public additionalFees: PriceModel;

  constructor(params: PriceSummaryModel) {
    this.subtotal = params.subtotal;
    this.shipping = params.shipping;
    this.tax = params.tax;
    this.discount = params.discount;
    this.total = params.total;
    this.additionalFees = params.additionalFees;
  }

  public static fromSDK(priceSummary: PriceSummary, modelContext: ModelContext) {
    return new PriceSummaryModel({
      subtotal: PriceModel.fromSDK(priceSummary.subtotal, modelContext),
      total: PriceModel.fromSDK(priceSummary.total, modelContext),
      tax: PriceModel.fromSDK(priceSummary.tax, modelContext),
      discount: PriceModel.fromSDK(priceSummary.discount, modelContext),
      additionalFees: PriceModel.fromSDK(priceSummary.additionalFees, modelContext),
      shipping: PriceModel.fromSDK(priceSummary.shipping, modelContext),
    });
  }
}
